import React from 'react';
import { setCurrentView } from 'core/utils';
import { PalletizingModeViewStore } from 'modules/order/stores';
import { PalletizingModeTemplate } from 'themes/modules/order/pages';

@setCurrentView((rootStore, componentProps) => new PalletizingModeViewStore(rootStore, componentProps), 'palletizingModeViewStore')
class PalletizingMode extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <PalletizingModeTemplate {...this.props} />;
	}
}

export default PalletizingMode;
